import User from "vamos/cockpit/model/User";
import { ResponseUserDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import ApiService from "vamos/cockpit/base/services/type/ApiService";

export default class UserHandler {

  private static _instance: UserHandler;

  private _oUser: User;

  public static getInstance() {
    if (!UserHandler._instance) {
      UserHandler._instance = new UserHandler();
    }
    return UserHandler._instance;
  }

  public async loadUser() {
    const userData: ResponseUserDto = await ApiService.getInstance().getRestJsonData("/user/userData");
    const oUser: User = new User(userData.content);

    this._oUser = oUser;
    return oUser;
  }

  public async getUser() {
      if(!this._oUser) {
          await this.loadUser();
      }

    return this._oUser;
  }

}
